import React from 'react'
import PropTypes from 'prop-types'

import InstagramStoryWrapper from '../InstagramStoryWrapper'
import StoryHeader from '../StoryHeader'
import InstagramStoryThumbnail from '../InstagramStoriesItem/InstagramStoryThumbnail'
import StoryButton from '../InstagramStoriesItem/StoryButton'

const SingleStoryPreview = ({
  pageId,
  sponsorPageId,
  mediaFile = {},
  actionValue = '',
  viewAdOnFacebook,
  elementInProgress,
  isInProgress = true
}) => {
  return (
    <InstagramStoryWrapper>
      <StoryHeader pageId={pageId} sponsorPageId={sponsorPageId} elementInProgress={elementInProgress} itemsCount={1} />
      <InstagramStoryThumbnail
        viewAdOnFacebook={viewAdOnFacebook}
        mediaFile={mediaFile}
        actionValue={actionValue}
        isActive={true}
        isInProgress={isInProgress}
      />
      <StoryButton actionValue={actionValue} />
    </InstagramStoryWrapper>
  )
}

SingleStoryPreview.propTypes = {
  pageId: PropTypes.string,
  sponsorPageId: PropTypes.string,
  mediaFile: PropTypes.object,
  actionValue: PropTypes.string,
  viewAdOnFacebook: PropTypes.string,
  elementInProgress: PropTypes.string,
  isInProgress: PropTypes.bool
}

export default SingleStoryPreview
